import script from "./Personalization.vue?vue&type=script&setup=true&lang=js"
export * from "./Personalization.vue?vue&type=script&setup=true&lang=js"

import "./Personalization.vue?vue&type=style&index=0&id=59f0d86a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f0d86a"]])

export default __exports__